export default "__VITE_ASSET__BgKmkF$x__"